import React, { useEffect } from "react";
// Utils
import { useEventRequest } from "hooks";
import { MedicinesTable } from "medicines/components/MedicinesTable";
import { Header, PageContent, PageHeader, Spacer } from "components";

const MedicineCabinet: React.FC = () => {
  const { eventsRequest } = useEventRequest();

  useEffect(() => {
    eventsRequest({ name: "med-cab-view" });
  }, []);

  return (
    <>
      <PageHeader>
        <Header title="Medicine Cabinet" subTitle="View and manage your medicines." />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={3} />

        <MedicinesTable />
      </PageContent>
    </>
  );
};

export default MedicineCabinet;
